import './home.scss'
import { useNavigate } from 'react-router-dom'
import bgimg from '../../assets/images/bg-cover.webp'
import {
  RMS_URL,
  REPORT_URL,
  ADMIN_PROJECT_ID,
  COMMANDCENTER_URL,
} from '../../utils/constants'
import {
  ADMINISTRATION_READ,
  ADMINISTRATION_WRITE,
  APPOINTMENTS_READ,
  APPOINTMENTS_WRITE,
  CAMP_VIEW_READ,
  IPD_READ,
  LMS_READ,
  OPD_READ,
  PATIENTS_READ,
  PATIENTS_WRITE,
  PHARMACY,
  RADIOLOGY_READ,
  RADIOLOGY_WRITE,
} from '../../utils/roles'
import odoo1 from '../../assets/images/User_icon.webp'
import odoo10 from '../../assets/images/imgs/admin.webp'
import odoo11 from '../../assets/images/imgs/innoment.webp'
import odoo4 from '../../assets/images/imgs/lab.webp'
import odoo5 from '../../assets/images/imgs/radiology.webp'
import odoo6 from '../../assets/images/imgs/ipd.webp'
import odoo9 from '../../assets/images/imgs/report.webp'
import odoo12 from '../../assets/images/imgs/rms.webp'
import odoo3 from '../../assets/images/imgs/appointment.webp'
import odo08 from '../../assets/images/imgs/billing.webp'
import odoo7 from '../../assets/images/imgs/Pharmacy.webp'
import odoo13 from '../../assets/images/imgs/commandCenter1.webp'
import odoo14 from '../../assets/images/camp_icon.svg'
import '../Icons/icons.scss'
import { useEffect, useState } from 'react'
import { startSxpProxy } from '../../utils/api'
import { useAppSelector } from '../../app/hooks'
import { selectSelectedLocationId } from '../location/locationSlice'
import KeycloakService from '../../utils/keycloakService'

const Menu = () => {
  const navigate = useNavigate()
  const locationId = useAppSelector(selectSelectedLocationId)

  const [billingUrl, setBillingUrl] = useState('')
  useEffect(() => {
    startSxpProxy(ADMIN_PROJECT_ID, 'odooLogin', {
      location: locationId,
    })
      .then((data) => setBillingUrl(data?.data?.auth_link))
      .catch((err) => console.error(err, 'err'))
  }, [locationId])

  const [pharmacyUrl, setPharmacyUrl] = useState('')
  useEffect(() => {
    startSxpProxy(ADMIN_PROJECT_ID, 'pharmacyLocation', {
      location: locationId,
    })
      .then((data) => setPharmacyUrl(data?.data?.auth_link))
      .catch((err) => console.error(err, 'err'))
  }, [locationId])
  const menuItems = [
    {
      name: 'Registration',
      Img: odoo1,
      url: '/patients',
      roles: [PATIENTS_READ, PATIENTS_WRITE],
    },
    {
      name: 'Appointment',
      Img: odoo3,
      url: '/appointments',
      roles: [APPOINTMENTS_READ, APPOINTMENTS_WRITE],
    },
    {
      name: 'OPD',
      Img: odoo11,
      url: '/opd',
      roles: [OPD_READ],
    },
    {
      name: 'Laboratory',
      Img: odoo4,
      url: '/lms/dashboard',
      roles: [LMS_READ],
    },
    {
      name: 'Radiology',
      Img: odoo5,
      url: '/radiology',
      roles: [RADIOLOGY_READ, RADIOLOGY_WRITE],
    },
    {
      name: 'IPD',
      Img: odoo6,
      url: '/bedIpd',
      roles: [IPD_READ],
    },
    {
      name: 'Pharmacy',
      Img: odoo7,
      url: pharmacyUrl,
      roles: [PHARMACY],
    },
    {
      name: 'Billing',
      Img: odo08,
      url: billingUrl,
      roles: [PATIENTS_READ],
    },
    {
      name: 'Reporting',
      Img: odoo9,
      url: REPORT_URL,
      roles: [ADMINISTRATION_READ, ADMINISTRATION_WRITE],
    },
    {
      name: 'RMS',
      Img: odoo12,
      url: RMS_URL,
      roles: [ADMINISTRATION_READ, ADMINISTRATION_WRITE],
    },
    {
      name: 'Command center',
      Img: odoo13,
      url: COMMANDCENTER_URL,
      roles: [ADMINISTRATION_READ, ADMINISTRATION_WRITE],
    },
    {
      name: 'Administration',
      Img: odoo10,
      url: '/administration',
      roles: [ADMINISTRATION_READ, ADMINISTRATION_WRITE],
    },
    {
      name: 'Camps',
      Img: odoo14,
      url: '/listOfCamps',
      roles: [CAMP_VIEW_READ],
    },
  ]
  const filteredMenuItems = menuItems?.filter((item) => {
    if (!item?.roles || item?.roles?.length === 0) return true
    return KeycloakService.hasRole(item?.roles)
  })

  const handleMenuClick = (url: string, name: string) => {
    if (name === 'Pharmacy' && pharmacyUrl) {
      window.open(pharmacyUrl, '_blank')
    } else if (name === 'Billing' && billingUrl) {
      window.open(billingUrl, '_blank')
    } else if (url.includes('http')) {
      window.open(url, '_blank')
    } else {
      navigate(url)
    }
  }

  return (
    <div
      className='home-content-height'
      style={{ backgroundImage: `url(${bgimg})` }}
    >
      <div className='icons_All' style={{ cursor: 'pointer' }}>
        {filteredMenuItems?.map((menuItem, index) => (
          <div
            key={index}
            onClick={() => handleMenuClick(menuItem?.url, menuItem?.name)}
          >
            <span className='myicons'>
              <img
                src={menuItem.Img}
                alt={`Odoo Icon ${index + 1}`}
                className='odoo-image'
              />
            </span>
            <p className='paragragh_icon'>{menuItem?.name}</p>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Menu
